// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","831":"component---src-pages-privacy-tsx"}[chunkId] + "-" + {"218":"2a80766223ea3da1171b","532":"089d3c89981a25f27ecd","831":"c342667c393e6114d796"}[chunkId] + ".js";
};